import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  setAuthErrorModalContent,
  setAuthModalContent,
  setShouldTimerStart,
  setShowAuthErrorModal,
  setShowAuthModal,
  setShowEnableMediumAuthBtn,
  setShowGetKuwaitAppBtn,
  setPaciErrorFlag
} from '../reducer/utilitySlice';
import {
  MOBILEID_AUTHENTICATION_STATUS,
  MOBILEID_STATUS,
} from '../services/common/endpoints';
import {
  getGlobalSettingValue,
  secondsToHms,
  setItemInSessionStorage,
} from '../services/common/utils';
import { callQueryapi } from '../services/http/callapi';
import { redirecturl } from '../services/common/redirect';
import { IS_2FA_DONE } from '../services/common/Constants';
import {setPaciLogin, setToastData} from "../reducer/utilitySlice";

const use2FA = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    utilityData: { globalSetting, isPaciLogin, civilID },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [transid, setTransid] = useState('');

  // const getMobileIdStatus = useMutation(
  //   () =>
  //     callQueryapi({
  //       queryKey: [{}, MOBILEID_STATUS, { source: 'transfertopartner' }],
  //     }),
  //   {
  //     onSuccess: ({ data: resData }) => {
  //       console.log('resData0000>', resData);
  //       if (resData?.status === '0') {
  //         dispatch(setShowAuthModal(true));

  //         const settingsArr = globalSetting
  //           ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
  //           : [];

  //         dispatch(
  //           setAuthModalContent({
  //             icon: getGlobalSettingValue(
  //               'beforeverificationicon',
  //               settingsArr
  //             ),
  //             title: getGlobalSettingValue(
  //               'beforeverificationtitle',
  //               settingsArr
  //             ),
  //             message: getGlobalSettingValue(
  //               'beforeverificationmsg',
  //               settingsArr
  //             ),
  //             btnText: getGlobalSettingValue(
  //               'beforeverificationbuttontext',
  //               settingsArr
  //             ),
  //           })
  //         );
  //       } else {
  //         dispatch(setShowAuthErrorModal(true));
  //         dispatch(
  //           setAuthErrorModalContent({
  //             message: t('somethingwentwrong'),
  //           })
  //         );
  //       }
  //     },
  //   }
  // );
  
  const settingsArr = globalSetting
    ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
    : [];

  const getMobileIdStatus = useQuery(
    [{}, MOBILEID_STATUS, 
      isPaciLogin? {"civilid": civilID,"source":"pacilogin"} : { "source": 'transfertopartner' }, {}],
    {
      enabled: false,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: ({ data: resData }) => {
        // for testing cases
        // case-1
        // const time1 = new Date();
        // const expirySeconds1 = isNaN(
        //   parseInt(getGlobalSettingValue('mobileidshowtimerlimit', settingsArr))
        // )
        //   ? 0
        //   : parseInt(
        //       getGlobalSettingValue('mobileidshowtimerlimit', settingsArr)
        //     );
        // // time1.setSeconds(time1.getSeconds() + 60 * 1); // 1 minutes timer
        // time1.setSeconds(time1.getSeconds() + expirySeconds1);

        // dispatch(
        //   setAuthModalContent({
        //     icon: getGlobalSettingValue(
        //       'loginapprovalrequesticon',
        //       settingsArr
        //     ),
        //     title: getGlobalSettingValue(
        //       'loginapprovalrequesttitle',
        //       settingsArr
        //     ),
        //     message: getGlobalSettingValue(
        //       'loginapprovalrequestmsg',
        //       settingsArr
        //     ),
        //     btnText: getGlobalSettingValue(
        //       'beforeverificationbuttontext',
        //       settingsArr
        //     ),
        //   })
        // );
        // setTransid(resData?.response?.transid);
        // dispatch(setShouldTimerStart(true));
        // props?.startTimer(time1);

        // case-2
        // dispatch(setShowEnableMediumAuthBtn(true));
        // dispatch(
        //   setAuthModalContent({
        //     icon: getGlobalSettingValue(
        //       'enablemediumauthicon',
        //       settingsArr
        //     ),
        //     title: getGlobalSettingValue(
        //       'enablemediumauthtitle',
        //       settingsArr
        //     ),
        //     message: getGlobalSettingValue(
        //       'enablemediumauthmsg',
        //       settingsArr
        //     ),
        //     btnText: getGlobalSettingValue(
        //       'enablemediumauthbuttontext',
        //       settingsArr
        //     ),
        //   })
        // );

        // case-3
        // dispatch(setShowGetKuwaitAppBtn(true));
        // dispatch(
        //   setAuthModalContent({
        //     icon: getGlobalSettingValue(
        //       'registermobileidfailureicon',
        //       settingsArr
        //     ),
        //     title: getGlobalSettingValue(
        //       'registermobileidfailuretitle',
        //       settingsArr
        //     ),
        //     message: getGlobalSettingValue(
        //       'registermobileidfailuremsg',
        //       settingsArr
        //     ),
        //     btnText: getGlobalSettingValue(
        //       'registermobileidfailurebuttontext',
        //       settingsArr
        //     ),
        //   })
        // );

        // actual functinality
        const time = new Date();
        const expirySeconds = isNaN(
          parseInt(getGlobalSettingValue('mobileidshowtimerlimit', settingsArr))
        )
          ? 0
          : parseInt(
            getGlobalSettingValue('mobileidshowtimerlimit', settingsArr)
            );
        time.setSeconds(time.getSeconds() + expirySeconds);
        //For Paci Login case default 2FA popup will not show. After api(rnHasMobileid) call only  will show popup.
        try{
          if(isPaciLogin){
            dispatch(setShowAuthModal(true))
          }
        }catch{}
        if (resData?.status === '0') {
            dispatch(
              setAuthModalContent({
                icon: getGlobalSettingValue(
                  'loginapprovalrequesticon_web',
                  settingsArr
                ),
                title: getGlobalSettingValue(
                  'loginapprovalrequesttitle',
                  settingsArr
                ),
                message: getGlobalSettingValue(
                  'loginapprovalrequestmsg',
                  settingsArr
                ),
                btnText: getGlobalSettingValue(
                  'beforeverificationbuttontext',
                  settingsArr
                ),
              })
            );

          setTransid(resData?.response?.transid);
          dispatch(setShouldTimerStart(true));
          props?.startTimer(time);
        } else {
          if (resData?.data?.verificationlevel?.toLowerCase() === 'low') {
            dispatch(setShowEnableMediumAuthBtn(true));
            dispatch(
              setAuthModalContent({
                icon: getGlobalSettingValue(
                  'enablemediumauthicon_web',
                  settingsArr
                ),
                title: getGlobalSettingValue(
                  'enablemediumauthtitle',
                  settingsArr
                ),
                message: getGlobalSettingValue(
                  'enablemediumauthmsg',
                  settingsArr
                ),
                btnText: getGlobalSettingValue(
                  'enablemediumauthbuttontext',
                  settingsArr
                ),
              })
            );
          } else {
            dispatch(setShowGetKuwaitAppBtn(true));
            if(isPaciLogin){
              dispatch(
                setAuthModalContent({
                  icon: getGlobalSettingValue(
                    'paciregistermobileidfailureicon',
                    settingsArr
                  ),
                  title: getGlobalSettingValue(
                    'registermobileidfailuretitle',
                    settingsArr
                  ),
                  message: getGlobalSettingValue(
                    'registermobileidfailuremsg',
                    settingsArr
                  ),
                  btnText: getGlobalSettingValue(
                    'paciregistermobileidfailurebuttontext',
                    settingsArr
                  ),
                })
              );
            }else{
            dispatch(
                setAuthModalContent({
                  icon: getGlobalSettingValue(
                    'registermobileidfailureicon_web',
                    settingsArr
                  ),
                  title: getGlobalSettingValue(
                    'registermobileidfailuretitle',
                    settingsArr
                  ),
                  message: getGlobalSettingValue(
                    'registermobileidfailuremsg',
                    settingsArr
                  ),
                  btnText: getGlobalSettingValue(
                    'registermobileidfailurebuttontext',
                    settingsArr
                  ),
                })
              );
            }
            dispatch(setPaciLogin(false));
            dispatch(setPaciErrorFlag(true))
          }
        }
      },
    }
  );

  const getAuthStatus = useMutation(
    () =>
      callQueryapi({
        queryKey: [
          {},
          MOBILEID_AUTHENTICATION_STATUS,
          { transid: transid, type: 'KUWAITMOBILEID' },
        ],
      }),
    {
      onSuccess: ({ data: resData }) => {
        // for testing
        // only for path /nojoom and /transferPoints-home
        // if (props?.navigateTo || props?.navigateUrl) {
        //   setItemInSessionStorage(IS_2FA_DONE, 'true');
        //   props?.pauseTimer();
        //   dispatch(setShouldTimerStart(false));
        //   dispatch(setShowAuthModal(false));
        //   if(location.pathname === '/nojoom' || location.pathname === '/transferPoints-home'){
        //     redirecturl(
        //       props?.navigateTo,
        //       navigate,
        //       null,
        //       null,
        //       props?.navigateToState
        //     );
        //   // for all other paths
        //   }else{
        //     redirecturl(
        //       props?.navigateUrl,
        //       navigate,
        //       null,
        //       null,
        //       props?.navigateState
        //     );
        //   }
        // }else{
        //   setItemInSessionStorage(IS_2FA_DONE, 'true');
        //   props?.pauseTimer();
        //   dispatch(setShouldTimerStart(false));
        //   dispatch(setShowAuthModal(false));

        //   if(props?.successFuncCall){
        //     props?.successFuncCall();
        //   }
        // }
        

        // actual functinality
        if (resData?.status === '0') {
          if(isPaciLogin){
            dispatch(setToastData({
              show: true,
              message: t("messageToast")
            })); 
            dispatch(setShowAuthModal(false));
            dispatch(setShouldTimerStart(false));
            setItemInSessionStorage(IS_2FA_DONE, 'true');
              setTimeout(()=>{
                navigate('/paci-managelines', {state:{transid: transid, civilID: civilID }})
              }, [1000]);
          }else{
          if (props?.navigateTo || props?.navigateUrl) {
            setItemInSessionStorage(IS_2FA_DONE, 'true');
            props?.pauseTimer();
            dispatch(setShouldTimerStart(false));
            dispatch(setShowAuthModal(false));

            // only for path /nojoom and /transferPoints-home
            if(location.pathname === '/nojoom' || location.pathname === '/transferPoints-home'){
              redirecturl(
                props?.navigateTo,
                navigate,
                null,
                null,
                props?.navigateToState
              );
            // for all other paths
            }else{
              redirecturl(
                props?.navigateUrl,
                navigate,
                null,
                null,
                props?.navigateState
              );
            }
          }else{
            setItemInSessionStorage(IS_2FA_DONE, 'true');
            props?.pauseTimer();
            dispatch(setShouldTimerStart(false));
            dispatch(setShowAuthModal(false));
            
            if(props?.successFuncCall){
              props?.successFuncCall();
            }
          }
        }
        } else {
          if (resData.code === '83709') {
            dispatch(
              setAuthModalContent({
                icon: getGlobalSettingValue(
                  'approvalrequestagainicon_web',
                  settingsArr
                ),
                title: getGlobalSettingValue(
                  'approvalrequestagaintitle',
                  settingsArr
                ),
                message: resData?.message,
                btnText: getGlobalSettingValue(
                  'approvalrequestagainbtntext',
                  settingsArr
                ),
              })
            );
            dispatch(setShouldTimerStart(false));
            // dispatch(setShouldTimerStart(false));
            // dispatch(setShowAuthModal(false));
            // dispatch(setShowAuthErrorModal(true));
            // dispatch(
            //   setAuthErrorModalContent({
            //     message: t('somethingwentwrong'),
            //   })
            // );
          }else if(!props?.isTimerRunning){
            dispatch(
              setAuthModalContent({
                icon: getGlobalSettingValue(
                  'approvalrequestagainicon_web',
                  settingsArr
                ),
                title: getGlobalSettingValue(
                  'approvalrequestagaintitle',
                  settingsArr
                ),
                message: getGlobalSettingValue(
                  'approvalrequestagainmsg',
                  settingsArr
                ).replace(
                  '!MIN!',
                  secondsToHms(
                    getGlobalSettingValue('mobileidshowtimerlimit', settingsArr)
                  )
                ),
                btnText: getGlobalSettingValue(
                  'approvalrequestagainbtntext',
                  settingsArr
                ),
              })
            );
            dispatch(setShouldTimerStart(false));
          }
        }
      },
    }
  );

  return {
    getMobileIdStatus,
    getAuthStatus,
  };
};

export default use2FA;
